<template>
  <img src="~/assets/svg/trident.svg" alt="Logo de trident" />
</template>